var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "income" } },
    [
      _c("DebtorTags", {
        attrs: { "has-codebtor": _vm.simulation.prospect.hasCodebtor },
      }),
      _c("div", { staticClass: "columns" }, [
        _c(
          "div",
          { staticClass: "column" },
          [
            _c(
              "div",
              {
                staticClass: "field-separation mb-5",
                attrs: { "data-cy": "income-data" },
              },
              [
                _c("p", [_vm._v("¿Qué tipo de ingresos tiene?")]),
                _c("div", { staticClass: "columns" }, [
                  _c(
                    "div",
                    { staticClass: "column is-4-desktop income-type" },
                    [
                      _c(
                        "b-select",
                        {
                          attrs: {
                            placeholder: "Seleccione una opción",
                            size: "is-small",
                            "data-cy": "income-type",
                            expanded: "",
                          },
                          model: {
                            value: _vm.incomeType,
                            callback: function ($$v) {
                              _vm.incomeType = $$v
                            },
                            expression: "incomeType",
                          },
                        },
                        [
                          _c(
                            "option",
                            { attrs: { value: "VARIABLE_TAXABLE" } },
                            [_vm._v(" Variable imponible ")]
                          ),
                          _c("option", { attrs: { value: "FIXED_TAXABLE" } }, [
                            _vm._v(" Renta fija "),
                          ]),
                        ]
                      ),
                      _vm.incomeType === "VARIABLE_TAXABLE"
                        ? _c("small", [
                            _vm._v("Ingrese los últimos tres montos variables"),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm.incomeType === "VARIABLE_TAXABLE"
                    ? _c("div", { staticClass: "column is-8-desktop" }, [
                        _c("div", { staticClass: "inner pb-2" }, [
                          _c(
                            "div",
                            { staticClass: "inner-col" },
                            [
                              _c(
                                "b-field",
                                { staticClass: "is-small" },
                                [
                                  _c("p", { staticClass: "control" }, [
                                    _c(
                                      "span",
                                      { staticClass: "button is-static" },
                                      [_vm._v("$")]
                                    ),
                                  ]),
                                  _c("b-input", {
                                    attrs: {
                                      size: "is-small",
                                      type: "number",
                                      placeholder: "0,00",
                                      expanded: "",
                                      "data-cy": "variable-month-one",
                                    },
                                    nativeOn: {
                                      input: function ($event) {
                                        return _vm.onSelectChange(
                                          _vm.incomeType,
                                          _vm.variableMonthOne,
                                          0
                                        )
                                      },
                                    },
                                    model: {
                                      value: _vm.variableMonthOne,
                                      callback: function ($$v) {
                                        _vm.variableMonthOne = $$v
                                      },
                                      expression: "variableMonthOne",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "inner-col" },
                            [
                              _c(
                                "b-field",
                                { staticClass: "is-small" },
                                [
                                  _c("p", { staticClass: "control" }, [
                                    _c(
                                      "span",
                                      { staticClass: "button is-static" },
                                      [_vm._v("$")]
                                    ),
                                  ]),
                                  _c("b-input", {
                                    attrs: {
                                      size: "is-small",
                                      type: "number",
                                      placeholder: "0,00",
                                      expanded: "",
                                      "data-cy": "variable-month-two",
                                    },
                                    nativeOn: {
                                      input: function ($event) {
                                        return _vm.onSelectChange(
                                          _vm.incomeType,
                                          _vm.variableMonthTwo,
                                          1
                                        )
                                      },
                                    },
                                    model: {
                                      value: _vm.variableMonthTwo,
                                      callback: function ($$v) {
                                        _vm.variableMonthTwo = $$v
                                      },
                                      expression: "variableMonthTwo",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "inner-col" },
                            [
                              _c(
                                "b-field",
                                { staticClass: "is-small" },
                                [
                                  _c("p", { staticClass: "control" }, [
                                    _c(
                                      "span",
                                      { staticClass: "button is-static" },
                                      [_vm._v("$")]
                                    ),
                                  ]),
                                  _c("b-input", {
                                    attrs: {
                                      size: "is-small",
                                      type: "number",
                                      placeholder: "0,00",
                                      expanded: "",
                                      "data-cy": "variable-month-three",
                                    },
                                    nativeOn: {
                                      input: function ($event) {
                                        return _vm.onSelectChange(
                                          _vm.incomeType,
                                          _vm.variableMonthThree,
                                          2
                                        )
                                      },
                                    },
                                    model: {
                                      value: _vm.variableMonthThree,
                                      callback: function ($$v) {
                                        _vm.variableMonthThree = $$v
                                      },
                                      expression: "variableMonthThree",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm.incomeType === "FIXED_TAXABLE"
                    ? _c("div", { staticClass: "column" }, [
                        _c("div", { staticClass: "inner" }, [
                          _c(
                            "div",
                            { staticClass: "inner-col" },
                            [
                              _c(
                                "b-field",
                                { staticClass: "is-small" },
                                [
                                  _c("p", { staticClass: "control" }, [
                                    _c(
                                      "span",
                                      { staticClass: "button is-static" },
                                      [_vm._v("$")]
                                    ),
                                  ]),
                                  _c("b-input", {
                                    attrs: {
                                      size: "is-small",
                                      type: "number",
                                      placeholder: "0,00",
                                      expanded: "",
                                    },
                                    nativeOn: {
                                      input: function ($event) {
                                        return _vm.onSelectChange(
                                          _vm.incomeType,
                                          _vm.fixedMonthOne,
                                          0
                                        )
                                      },
                                    },
                                    model: {
                                      value: _vm.fixedMonthOne,
                                      callback: function ($$v) {
                                        _vm.fixedMonthOne = $$v
                                      },
                                      expression: "fixedMonthOne",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "column" }),
                          _c("div", { staticClass: "column" }),
                        ]),
                      ])
                    : _vm._e(),
                ]),
              ]
            ),
            _vm._l(_vm.incomeConfig, function (config, index) {
              return _c(
                "div",
                {
                  key: config.id,
                  staticClass: "evaluation-field-container field-separation",
                },
                [
                  _c("verify-inputs", {
                    attrs: {
                      id: config.id,
                      "data-cy": `conf-${config.id}`,
                      label: config.label,
                      "label-description": config.labelDescription,
                      visible: config.visible,
                      template: config.template,
                      "is-array": config.isArray,
                    },
                    on: {
                      "update:visible": function ($event) {
                        return _vm.$set(config, "visible", $event)
                      },
                      "switch-change": function ($event) {
                        return _vm.onSwitchChange($event, config.id)
                      },
                      "add-input": function ($event) {
                        return _vm.addInput(index)
                      },
                      "remove-input": function ($event) {
                        return _vm.removeInput(index, $event)
                      },
                    },
                    nativeOn: {
                      input: function ($event) {
                        return _vm.onInputChange($event.target, config.id)
                      },
                    },
                    model: {
                      value: config.value,
                      callback: function ($$v) {
                        _vm.$set(config, "value", $$v)
                      },
                      expression: "config.value",
                    },
                  }),
                ],
                1
              )
            }),
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "column pl-5" },
          [
            _c("TableSummary", {
              attrs: {
                "data-cy": "income-result",
                title: "Renta promedio calculada",
                "icon-label": _vm.totalIncomeCardSummary,
                "show-icon-label": "",
                data: _vm.incomeCardSummary,
              },
            }),
            _c("DocumentsVerification", {
              attrs: {
                label: _vm.label,
                type: "income",
                "evaluation-id": _vm.evaluationId,
                "one-client-id": _vm.oneClientId,
                "validate-documents": _vm.hasNewIncome,
              },
              on: { "documents-uploaded": _vm.handleDocumentsUploaded },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }